import axios from 'axios'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {setCurrentPage, setError} from '../../../../redux/slices/customerSlices'
import {
  filterSelector,
  resetFilterCustomer,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {fetchCustomers, headers} from '../../../../services/fetcher'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {ButtonGroups} from './ButtonGroups'
import {RowFilter} from './RowFilter'
import {StyledCard} from '../../../../components/StyledCard'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {KTSVG} from '../../../../_metronic/helpers'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import swal from 'sweetalert'
import API from '../../../../api/modules/customer'
import i18next from 'i18next'
import { checkToken, loginAs } from 'src/api/modules/auth'
import { setAuthUser, setCredential } from 'src/redux/slices/authSlices'
import { setToken } from 'src/_metronic/redux/content'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

type Props = {
  className: string
}

const TableCustomer: React.FC<Props> = ({className}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [customers, setCustomers] = useState([])
  const [page, setPage] = useState(1)
  const [links, setLinks] = useState([])

  const [showEditPassword, setShowEditPassword] = useState(false)
  const [loadingEditPassword, setLoadingEditPassword] = useState(false)
  const [selectedId, setSelectedId] = useState<any>(null)

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loadingSendEmail, setLoadingSendEmail] = useState<any[]>([])

  const hakAkses = HakAkses()
  const dispath = useDispatch()
  const navigate = useNavigate()

  const {t} = useTranslation()
  const {filterCustomer: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const onReloadTable = () => {
    dispatch(resetFilterCustomer())
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({colSpan: 10, onReloadTable})

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    return (page ?? 1) * per - per
  }, [page, filter?.per_page])

  const onFetchCustomers = useCallback(() => {
    setIsLoading(true)
    setIsError(false)

    fetchCustomers(filter)
      .then((res) => {
        const data = res.data.data
        setCustomers(data.data)
        setLinks(data.links)
        setPage(data.current_page)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setIsLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setIsLoading(true)
      setIsError(false)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filter)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setCustomers(data.data)
      setLinks(data.links)
      setCurrentPage(data.current_page)
    } catch (error: any) {
      setError(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  const showModalEditPassword = (id: any) => {
    setSelectedId(id)
    setShowEditPassword(true)
  }
  const closeEditPassword = () => {
    setShowEditPassword(false)
  }
  const editPassword = () => {
    // validate
    if(!password){
      return swal({
        title: t('The password field is required.'),
        icon: 'error',
      })
    }
    if(password != confirmPassword){
      return swal({
        title: t('The password confirmation does not match.'),
        icon: 'error',
      })
    }

    processEditPassword()
  }
  const resendEmail = (id: any) => {
    const ids = [...loadingSendEmail];
    ids.push(id)

    processResendEmail(id)
  }

  const processEditPassword = () => {
    setLoadingEditPassword(true);
    API.updatePassword(selectedId, {
      lang: i18next.language,
      password
    }).then((resp: any) => {
      swal({
        title: t('update-password-success'),
        icon: 'success',
      }).then(() => {
        setShowEditPassword(false)
      })
    }).catch((err: any) => {
      swal({
        title: err.response.data.message,
        icon: 'error',
      })
    }).finally(() => {
      setLoadingEditPassword(false);
    })
  }
  const processResendEmail = (id: any) => {
    API.sendEmail(id).then((resp) => {
      swal({
        title: t('resend-mail-success'),
        icon: 'success',
      })
    }).catch((err: any) => {
      swal({
        title: err.response.data.message,
        icon: 'error',
      })
    }).finally(() => {
      const ids = [...loadingSendEmail];
      var index = ids.indexOf(id);
      if (index !== -1) {
        ids.splice(index, 1);
      }
      setLoadingSendEmail(ids)
    })
  }

  useEffect(() => {
    const getData = setTimeout(onFetchCustomers, 1000)
    return () => clearTimeout(getData)
  }, [onFetchCustomers])

  useEffect(() => {
    onReloadTable()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [loadingImpersonate, setLoadingImpersonate] = useState<any>(null)
  const impersonateUser = async (id: any) => {
    setLoadingImpersonate(id)
    await loginAs(id)
      .then(({data: resp}) => {
        if (!resp.data.error) {
          localStorage.setItem('impersonating_user_id', localStorage.getItem('user_code') || '')
          dispatch(setAuthUser(resp.data))
          localStorage.setItem('role-flag', resp.data.credential.role_flag)
          localStorage.setItem('user_code', resp.data.credential.username)
          localStorage.setItem('role_flagg', resp.data.credential.role_flag)
          localStorage.setItem('sector_ids', resp.data.credential.sector_ids)
          localStorage.setItem('email', resp.data.credential.email)
          // localStorage.setItem('name', resp.data.credential.name)
          if (resp.data.credential.role_flag == null)
            localStorage.setItem(
              'username',
              resp.data.credential.customer?.title != null
                ? resp.data.credential.customer?.title + ' ' + resp.data.credential.customer?.name
                : resp.data.credential.customer?.name
            )
          else localStorage.setItem('username', resp.data.credential.name)
          localStorage.setItem('user-id', resp.data.credential.user_id)
          localStorage.setItem('cust-code', resp.data.credential.customer_code)
          localStorage.setItem('cus-grup', resp.data.credential.customer_account_group)
          localStorage.setItem('cus-grupp', resp.data.credential.customer_account_group)
          localStorage.setItem('cust-group', resp.data.credential.customer_account_group)
          localStorage.setItem('user-segment', resp.data.credential.segments)
          localStorage.setItem('user-product-type', resp.data.credential.product_types)
  
          if (!resp.data.error) {
            localStorage.setItem('token', resp.data.access_token)
            checkToken(resp.data.access_token).then((res: any) => {
              dispatch(setCredential(res.data.credential))
              try{
                const test = atob(resp.data.credential)
                const temp = JSON.parse(test)
                localStorage.setItem('credential', test)
                localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
                localStorage.setItem('credential-decoded', test)
              }catch(e){}
            })
            if (!resp.data.accesses) {
              // console.log('ga punya')
            } else {
              localStorage.setItem('access', JSON.stringify(resp.data.accesses.role_accesses))
              localStorage.setItem('accesses', JSON.stringify(resp.data.accesses))
              // dispath(setAccesses(JSON.stringify(resp.data.accesses.role_accesses)))
            }
            dispath(setToken(resp.data.access_token))
            navigate('/dashboard')
        }
      }
    })
      .catch((error) => {
        swal({
          title: error.response?.data?.message || error.message,
          icon: 'error',
        })
      })
      .finally(() => {
        setLoadingImpersonate(null)
      })
  }

  const roleUser: any = localStorage.getItem('role-flag')

  return (
    <>
      <StyledCard>
        <ButtonGroups />

        <TableUI.TableWrapper>
          <TableUI.Table>
            <TableUI.THead>
              <tr>
                <th>{t('No')}</th>
                <th>{t('Customer Code')}</th>
                <th>{t('Name')}</th>
                <th>{t('Customer Account Group')}</th>
                <th>{t('text')}</th>
                <th>{t('Company Type')}</th>
                <th>{t('Company Type Description 2')}</th>
                <th>{t('Address')}</th>
                <th>{t('No Telp')}</th>
                <th>Email</th>
                <th>{t('kontrak-aksi')}</th>
              </tr>
            </TableUI.THead>
            <TableUI.TBody>
              <RowFilter />

              {isLoading ? (
                <RowLoader />
              ) : isError ? (
                <RowErrorFetch />
              ) : customers?.length === 0 ? (
                <RowEmptyData />
              ) : (
                customers?.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>{index + 1 + rowNumber}</td>
                    <td>{item.customer_code}</td>
                    <td>{`${item.title}. ${item.name}`}</td>
                    <td>{item.customer_account_group}</td>
                    <td>{t(item.text)}</td>
                    <td>{item.company_type}</td>
                    <td>{item.company_type_description}</td>
                    <td>{item.address?.street1}</td>
                    <td>{item.contact?.no_telp ?? '-'}</td>
                    <td>{item.contact?.email ?? '-'}</td>
                    <td>
                          <div className='d-flex justify-content-center'>
                          {hakAkses?.update && (
                            <button
                              type='button'
                              onClick={() => showModalEditPassword(item.customer_code)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ms-3'
                              title={t('update-password')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                          {hakAkses?.update && (
                              loadingSendEmail.includes(item.customer_code) ? <button
                                type='button'
                                onClick={() => {}}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ms-3'
                                title={t('resend-mail')}
                              >
                              <Spinner animation='border' variant='primary' size='sm' />
                            </button>
                              : <button
                              type='button'
                              onClick={() => resendEmail(item.customer_code)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ms-3'
                              title={t('resend-mail')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/mail.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}

                          {roleUser == 'admin' && (
                            <button
                              className='btn btn-icon btn-primary btn-sm ms-2'
                              title='Login as'
                              onClick={() => impersonateUser(item.customer_code)}
                            >
                              <i className='fas fa-sign-in'></i>
                            </button>
                          )}
                          </div>
                    </td>
                  </tr>
                ))
              )}
            </TableUI.TBody>
          </TableUI.Table>
        </TableUI.TableWrapper>

        <Pagination paginate={paginateNumber} test={links} />
      </StyledCard>

    <Modal
    show={showEditPassword}
    onHide={closeEditPassword}
    backdrop='static'
    keyboard={false}
    centered
    scrollable
  >
    <Modal.Header closeButton>
      <Modal.Title>{t('update-password')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <>
          <Form.Group className='mb-5'>
            <Form.Label>{t('New-Password')}</Form.Label>
            <Form.Control
              autoComplete="new-password"
              type='password'
              placeholder={t('New-Password')}
              onChange={(e: any) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5'>
            <Form.Label>{t('Konfirmasi')} Password</Form.Label>
            <Form.Control
              autoComplete="new-password"
              type='password'
              placeholder={t('Konfirmasi')}
              onChange={(e: any) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>
         

          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={editPassword} disabled={loadingEditPassword}>
              {loadingEditPassword ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('update-password')
              )}
            </Button>
          </div>
        </>
    </Modal.Body>
    </Modal>
    </>
  )
}

export {TableCustomer}
